import type { ButtonHTMLAttributes } from 'react'

type Variant = 'primary' | 'secondary' | 'ghost'

const VARIANTS: Record<Variant, string> = {
  primary:
    'bg-roast-600 text-crema-50 hover:bg-roast-700 dark:bg-roast-500 dark:hover:bg-roast-400 dark:text-roast-900',
  secondary:
    'border border-crema-300 dark:border-roast-600 hover:bg-crema-100 dark:hover:bg-roast-700',
  ghost: 'hover:bg-crema-100 dark:hover:bg-roast-700',
}

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  isLoading?: boolean
}

export default function Button({
  variant = 'primary',
  isLoading = false,
  className = '',
  disabled,
  children,
  ...rest
}: Props) {
  return (
    <button
      {...rest}
      disabled={disabled ?? isLoading}
      aria-busy={isLoading}
      className={`focus-visible:outline-roast-500 rounded-lg px-4 py-2 text-sm font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${VARIANTS[variant]} ${className}`}
    >
      {children}
    </button>
  )
}
